window.slate = window.slate || {};
window.theme = window.theme || {};

// global variables
var html = $('html');
var body = $('body');
var winWidth = $(window).width();
var winHeight = $(window).height();
theme.mobileBrkp = 768;
theme.tabletBrkp = 981;

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }
      
      
      if (typeof MagicZoom != 'undefined') {
      	
        
        
        var newSelectors = $('.MagicToolboxSelectorsContainer a[title*="'+variant.title+'"]');
        
        if (newSelectors.length) {
          	MagicZoom.stop();
          	$('.MagicToolboxSelectorsContainer a').removeAttr('data-zoom-id').addClass('hidden').hide();
        	newSelectors.each(function(index){
        		$(this).attr('data-zoom-id', $(this).attr('x-data-zoom-id')).removeClass('hidden').show();
              	if (index == 0) {
                  $('.MagicZoomPlus').attr('href', $(this).attr('href'))
                  $('.MagicZoomPlus').attr('data-image', $(this).attr('data-image'))
                  $('.MagicZoomPlus').attr('data-image-2x', $(this).attr('data-image-2x'))
                  $('.MagicZoomPlus img').attr('src', $(this).attr('data-image'))
                  $('.MagicZoomPlus img').attr('srcset', $(this).attr('data-image-2x')+' 2x')
                  console.warn($(this))
              	}
        	})
            MagicZoom.start();
        } 
        
        
        
        
        
        
      }
      
//       	if (typeof MagicZoom != 'undefined' && $('a[data-variants*="'+variant.id+'"]').length) {
// 			MagicZoom.switchTo($('.MagicZoomPlus').attr('id'), $('a[data-variants*="'+variant.id+'"]')[0])
// 		}


      // cache selectors
      var $prodSku = $('.js-product-sku'),
          $prodBarcode = $('.js-product-barcode'),
          $prodAvailability = $('.js-product-availability');

      // BEGIN SWATCHES
      var selector = this.originalSelectorId;
      if (variant) {

         var variantMetaFields       = JSON.parse($('[data-product-metafields-json]').html());
         var variantId               = variant.id.toString();
         var productAvailabilityText = 'Ships Today';

          var form = $(selector).closest('form');
          for (var i=0,length=variant.options.length; i<length; i++) {
              var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
              if (radioButton.length) {
                  radioButton.get(0).checked = true;
              }
          }

          // Set availablity text
          if (variantMetaFields[variantId].availability != '') {
            productAvailabilityText = variantMetaFields[variantId].availability;
          } else if (!variant.available) {
            productAvailabilityText = 'Out of Stock';
            $('.low-inventory').addClass('hide');
          } else if(variant.available) {
            console.log(variant);
            var var_id = variant.id;
            var var_inven = $('select.no-js option[value*='+ var_id+']').attr('data-inven');
            if(var_inven < 50){
              $('.low-inventory').removeClass('hide');
            }
            else{
              $('.low-inventory').addClass('hide');
            }
          }

          // DOM updates
          $prodSku.text(variant.sku);
          $prodBarcode.text(variant.barcode);
          $prodAvailability.text(productAvailabilityText);

          // affirm snippet
//           $('.affirm-as-low-as').attr('data-amount',variant.price);
//           affirm.ui.refresh();

      }
      // END SWATCHES

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */
 $(document).ready(function(){
   // call slick function here so image dissappears on load
   if($('#arqspin-mp4')[0]) {
     setTimeout(function() {
       $('#arqspin-mp4')[0].play();
     }, 2000);
   }

 });

theme.Product = (function() {

  var selectors = {
    addToCartForm: '[data-add-to-cart-form]',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',

    // pdp slider
    mainSlider: '[data-media-feature]',
    navSlider: '[data-media-nav]',
    mediaImage: '[data-media-image]',

    // pdp videos
    productVideos: '[data-product-videos]',

    // pdp featured blog
    featuredArticlesContainer: '[data-featured-articles]',
    featuredArticleHandles: '[data-featured-article-handles]',

    // pdp related products
    productRelatedSlider: '[data-product-related]',

    // scroll box events
    productQty: '[data-product-qty]',
    productTriggerAddCart: '[data-trigger-add-to-cart]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));


    // pdp slider variant change handler
    this.$container.on('variantChange' + this.namespace, this.handlePdpMediaSlider.bind(this));

    // initial pdp slider on page load for single product and products with variants
    if (this.variants.product.variants.length > 1) {
      this.handlePdpMediaSlider();
    } else {
      this.initPdpMediaSlider(true);
    }

    if ($(selectors.productVideos).find('.product-videos__item')) {
      // initialize product videos
      this.handlePdpVideos();
    }

    // featured blog
    if ($(selectors.featuredArticleHandles).html()) {
      this.handlePdpFeaturedArticles($(selectors.featuredArticleHandles).html());
    }

    // initialize related prducts slider
    this.handleRelatedProducts();

    // product qty change handler
    this.$container.on('change', selectors.productQty, this.handleProductQtyUpdates);

    // scroll box add to cart click handler
    this.$container.on('click', selectors.productTriggerAddCart, this.handleproductTriggerAddCart);

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

       // affirm snippet
       $('.affirm-as-low-as').attr('data-amount',variant.price);
       affirm.ui.refresh();
      
      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Initializes PDP media / images slider
     */
    initPdpMediaSlider: function(isSingleProduct) {
      var breakpointMobile = 700,
          isChanging = false,
          isFiltered = false;

      if (isSingleProduct) {
        $(selectors.mediaImage).find('img').parent().addClass('media-slide');
      }

      if ($(selectors.mainSlider).hasClass('slick-initialized') && $(selectors.navSlider).hasClass('slick-initialized')) {
        return;
      }

      $(selectors.mainSlider).on('init breakpoint', function(event, slick){
          if ( ! isChanging ) {
            isChanging = true;
            if ( slick.activeBreakpoint && slick.activeBreakpoint <= 767) {
              if ( ! isFiltered ) {
                slick.slickFilter(':not(.arqspin-mobile-hidden)');
                isFiltered = true;
              }
            } else {
              if ( isFiltered ) {
                slick.slickUnfilter();
                isFiltered = false;
              }
            }
            isChanging = false;
          }
        }).slick({
          rows: 0,
          slide: '.media-slide',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: false,
          responsive: [
            {
                breakpoint: 767,
                settings: {
                    dots: true
                }
            },
          ]
        });

      $(selectors.navSlider).slick({
        rows: 0,
        slide: '.media-slide',
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        asNavFor: selectors.mainSlider,
        focusOnSelect: true
      });
    },

    /**
     * Destroys PDP media / images slider
     */
    destroyPdpMediaSlider: function() {
      if ($(selectors.mainSlider).hasClass('slick-initialized') && $(selectors.navSlider).hasClass('slick-initialized')) {
        $(selectors.mainSlider).slick('unslick');
        $(selectors.navSlider).slick('unslick');
      }
    },

    /**
     * Update image slider based on variant selected
     */
    handlePdpMediaSlider: function(evt) {
      // get currently selcted variant from event or dom if initial page load
      var selectedVariantColor
        = evt
        ? evt.variant.title
        : $(selectors.addToCartForm).find('input[name="option-0"]:checked').val();

      if (evt) { // variant change
        this.destroyPdpMediaSlider();
        $(selectors.mediaImage).removeClass('media-slide');
        $(selectors.mediaImage).find('img[alt*="' + selectedVariantColor  + '"]').parent().addClass('media-slide');
        this.initPdpMediaSlider();
      } else {  // initial page load
        $(selectors.mediaImage).find('img[alt*="' + selectedVariantColor  + '"]').parent().addClass('media-slide');
        this.initPdpMediaSlider();
      }
    },

    /**
     *  Handle product videos section
     */
    handlePdpVideos: function() {
      var prodVideos = $(selectors.productVideos).find('.product-videos__item');

      if (prodVideos.length > 1) {
        $(selectors.productVideos).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
        });
      }

      prodVideos.on('click', function() {
        var vid_id = $(this).attr('data-video-id');
        $(this).html('<div class="intrinsic-container intrinsic-container-16x9"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + vid_id + '/?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>');
      });


    },

    /**
     *  Handle product feature blog section
     */
    handlePdpFeaturedArticles: function(article_handles) {

      var article_handles_arr;
      var article_objects_arr = [];

      try {
        article_handles_arr = JSON.parse(article_handles).product_articles_array;
      } catch (err) {
        console.error('Eror parsing articles into json');
      }

      // gets each artilce date synchronously
      article_handles_arr.forEach(function(handle, index) {
        // get data from alternat template article.data.liquid
        var url = '/blogs/learn/' + handle + '?view=data';
        $.ajax({
            url: url,
            async: false
        })
        .done(function( html ) {
          var data;
          try {
            data = JSON.parse(html.replace(/<!--[\s\S]+?-->/g,"")); // removes any comments that come back from ajax call
          } catch(error) {
            console.error('an error occured in handlePdpFeatureBlog()', error);
            return;
          }
          //console.log('data', data);
          article_objects_arr.push(data);
        })
        .fail(function( error ) {
            console.error( 'error in handlePdpFeatureBlog()', error );
        });
      });

      // returns formatted date
      function getFormattedDate(article) {
        var month_map = {
          0 : 'Jan',
          1 : 'Feb',
          2 : 'Mar',
          3 : 'Apr',
          4 : 'May',
          5 : 'Jun',
          6 : 'Jul',
          7 : 'Aug',
          8 : 'Sep',
          9 : 'Oct',
          10 : 'Nov',
          11 : 'Dec'
        }
        // format date
        var date = new Date(article.published_at);
        var formatted_date = month_map[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
        return formatted_date;
      }

      function render(articles) {
        var num_articles = articles.length;
        var markup = '';

        if (num_articles == 1) { // only one post 50%
          markup += '<div class="col-xs-12 col-sm-6 blog__featured-small">' +
                      '<div class="blog__featured-item blog__featured-aspect-box">' +
                        '<div class="blog__featured-aspect-box-bg" style="background-image:url(' + articles[0].image + ')"></div>' +
                        '<a href="' + articles[0].url + '">' +
                          '<div class="blog__featured-aspect-box-overlay">' +
                            '<div class="blog__featured-content">' +
                              '<p>' + articles[0].title + '</p>' +
                              '<p>' + getFormattedDate(articles[0]) + '</p>' +
                            '</div>' +
                          '</div>' +
                        '</a>' +
                      '</div>' +
                    '</div>';
        } else if (num_articles == 2) { // two posts 50/50
          article_objects_arr.forEach(function(article, index) {
            markup += '<div class="col-xs-12 col-sm-6 blog__featured-small">' +
                          '<div class="blog__featured-item blog__featured-aspect-box">' +
                            '<div class="blog__featured-aspect-box-bg" style="background-image:url(' + article.image + ')"></div>' +
                            '<a href="' + article.url + '">' +
                              '<div class="blog__featured-aspect-box-overlay">' +
                                '<div class="blog__featured-content">' +
                                  '<p>' + article.title + '</p>' +
                                  '<p>' + getFormattedDate(article) + '</p>' +
                                '</div>' +
                              '</div>' +
                            '</a>' +
                          '</div>' +
                        '</div>';
          });
        } else { // three posts grid
          article_objects_arr.forEach(function(article, index) {
            if (index == 0) {
              markup += '<div class="col-xs-12 col-sm-8 blog__featured-large">' +
                            '<div class="blog__featured-item blog__featured-aspect-box">' +
                              '<div class="blog__featured-aspect-box-bg" style="background-image:url(' + article.image + ')"></div>' +
                              '<a href="' + article.url + '">' +
                                '<div class="blog__featured-aspect-box-overlay">' +
                                  '<div class="blog__featured-content">' +
                                    '<p>' + article.title + '</p>' +
                                    '<p>' + getFormattedDate(article) + '</p>' +
                                  '</div>' +
                                '</div>' +
                              '</a>' +
                            '</div>' +
                          '</div>';
            } else {
              if (index == 1) {
                markup += '<div class="col-xs-12 col-sm-4 blog__featured-small">';
              }
              markup += '<div class="blog__featured-item blog__featured-aspect-box">' +
                          '<div class="blog__featured-aspect-box-bg" style="background-image:url(' + article.image + ')"></div>' +
                          '<a href="' + article.url + '">' +
                            '<div class="blog__featured-aspect-box-overlay">' +
                              '<div class="blog__featured-content">' +
                                '<p>' + article.title + '</p>' +
                                '<p>' + getFormattedDate(article) + '</p>' +
                              '</div>' +
                            '</div>' +
                          '</a>' +
                        '</div>';

              if (index == 2) {
                markup += '</div>';
              }

            }
          });
        }

        // append to dom
        $(selectors.featuredArticlesContainer).append(markup);
      }

      // kick off render function
      render(article_objects_arr);

    },

    /**
     *  Handle Related Products Slider
     */
    handleRelatedProducts: function() {
      $(selectors.productRelatedSlider).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        responsive: [
          {
              breakpoint: 767,
              settings: {
                  dots: true,
                  slidesToShow: 1
              }
          },
        ]
      });
    },

    /**
     *  handle product qty changes / keeps scroll box in sync
     */
    handleProductQtyUpdates: function() {
        $(selectors.productQty).not($(this)).val($(this).val());
    },

    /**
     * triggers form submit when clicking scroll box add to cart
     */
    handleproductTriggerAddCart: function() {
      $(selectors.addToCartForm).submit();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  // if($('#qab_container')){
  //   $('body').addClass('body-padding');
  // };
   var gridIcon = $('.grid-icon');
  var listIcon = $('.list-icon');
  var listLayout = $('.list-layout');
  var gridLayout = $('.grid-layout');
  var dualLayout = $('.dual-layout');

  gridIcon.on('click', function(){
      gridIcon.addClass('active');
      listIcon.removeClass('active');
      // gridLayout.show();
      // listLayout.hide();
      dualLayout.addClass('grid-layout');
      dualLayout.removeClass('list-layout');
  });
  listIcon.on('click', function(){
      listIcon.addClass('active');
      gridIcon.removeClass('active');
      // listLayout.show();
      // gridLayout.hide();
      dualLayout.removeClass('grid-layout');
      dualLayout.addClass('list-layout');
  });



  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // sliders
  $('.section-collection-slider').each(function(i) {
      var thisSectionId = $(this).data('section-id');
      theme.layoutSlider(thisSectionId, 'img');
      theme.layoutSlider(thisSectionId, 'text');
  });

  // navigation - desktop
  if($(window).width() > 1024){
    $('.main-navigation__list-item-link').on('mouseenter', function(e) {
      var linkId = $(this).data('link');
      var $dropDownContainer = $('.nav-desktop__container');

      if ($dropDownContainer.find($(linkId)).length) {
        theme.handleNavDropdown($dropDownContainer.find($(linkId)));
        $dropDownContainer.find($(linkId)).addClass('visible');
      } else {
        theme.clearNavDropdowns();
      }
    });
  }  

  // navigation - desktop
  $('#shopify-section-header').on('mouseleave', function(e) {
    theme.clearNavDropdowns();
  });

  // navigation - mobile (hamburger)
  $('.hamburger').on('click', function(e) {
    e.preventDefault();
    if ($(this).hasClass('opened')) {
      theme.handleMobileNav('opened');
    } else {
      theme.handleMobileNav('closed');
    }
  });

  // window resize
  var window_width = $(window).width();
  $(window).resize(function(e) {
    winWidth = $(window).width();
    if (winWidth > theme.mobileBrkp && body.hasClass('nav-mobile-open')) {
      theme.handleMobileNav('opened'); // removes mobile classes when window is resized
    }

    if(((window_width - $(window).width()) > 5) && ($(window).width() > 768)){
        listIcon.hide();
        gridIcon.hide();
        gridLayout.show();
        listLayout.hide();
        gridIcon.addClass('active');
        listIcon.removeClass('active');
    } else {
        listIcon.show();
        gridIcon.show();
    }

  });


  // general

  // initiaize accordions
  $('[data-show-more-container]').each(function(index, elem) {
    theme.showMore(elem);
  });

  // intialize show more modules
  $('.accordion').each(function(index, elem) {
    theme.accordion(elem);
  });

  theme.triggerActive();

  // initialize back to top
  theme.handleBackToTop();

  // prop 65 popup trigger
  $(document).on('click', '.js-prop-65-trigger', function(e) {
    theme.mfpOpen('prop-65');
    e.preventDefault();
  });

  // prop 65 popup trigger
  $(document).on('click', '.js-product-type-trigger', function(e) {
    var productType = $(this).data('product-type');
    theme.mfpOpen(productType);
    e.preventDefault();
  });

  // cart discount fields
  $('.js-cart__discount-input').on('input', function(e) {
    e.preventDefault();
    if ($(this).val() != '') {
      $(this).next().prop('disabled', false);
    } else {
      $(this).next().prop('disabled', true);
    }
  });

  // collection
  theme.collectionSort();

//   // fresh chat open trigger
//   $('.js-chat-trigger').on('click', function(e) {
//     theme.freshChatOpen(e);
//   });

//   setTimeout(function(){
//     theme.freshChatOpenContact();
//   }, 2000);

});

// // open fresh chat
// theme.freshChatOpen = function(e) {
//   e.preventDefault();
//   if (window.fcWidget) {
//     window.fcWidget.open();
//   }
// }

// // always open fresh chat on contact-us page
// theme.freshChatOpenContact = function() {
//   if(window.location.pathname === "/pages/contact-us" ) {
//     if (window.fcWidget) {
//       window.fcWidget.open();
//     }
//   }
// }


// accordion
theme.accordion = function(element) {
  $(element).find('.js-has-content').on( 'click', function(e){
    e.preventDefault();
    var target = $(this);
    target.toggleClass('active');
    target.next().slideToggle('fast');
    $(".accordion__content").not($(this).next()).slideUp('fast');
    $(".js-has-content").not($(this)).removeClass('active');
  });
}

//toggle active class on traget div
theme.triggerActive = function () {
  var trigger = $('.js-toggle-trigger');
  var activeClass = 'js-active';

  trigger.click(function(e) {
      var thisTarget = $(this).attr('href');
      if ($(this).hasClass(activeClass)) {
          $(this).removeClass(activeClass);
          $(thisTarget).removeClass(activeClass);
      } else {
          $(this).addClass(activeClass);
          $(thisTarget).addClass(activeClass);
      }
      e.preventDefault();
  });
};

// handle mobile nav
theme.handleMobileNav = function(state) {
  if (state === 'opened') {
    body.removeClass('nav-mobile-open');
    $('.hamburger').removeClass('opened');
    $('#nav-mobile').removeClass('opened');
  } else if (state === 'closed') {
    body.addClass('nav-mobile-open');
    $('.hamburger').addClass('opened');
    $('#nav-mobile').addClass('opened');
  }
}

// handle nav dropdown
theme.handleNavDropdown = function(target) {
  if (!target.hasClass('visible')) {
    theme.clearNavDropdowns();
    target.addClass('visible');
  } else {
    // do nothing the dropdown is displaying
  }
}

// hides all nav dropdowns
theme.clearNavDropdowns = function() {
  $('.nav-desktop_dropdown').each(function() {
    $(this).removeClass('visible');
  });
}

// handle back to top
theme.handleBackToTop = function() {
    var $backToTop = $('.back-to-top');
    var $pdpScrollBox = $('.product__scroll-box');
    var offset = 300, duration = 500;

    $(window).scroll(function() {
      if ($(this).scrollTop() > offset) {
        $backToTop.fadeIn(duration);
        if ($pdpScrollBox) {
          $pdpScrollBox.fadeIn(duration);
        }
      }
      else {
        $backToTop.fadeOut(duration);
        if ($pdpScrollBox) {
          $pdpScrollBox.fadeOut(duration);
        }
      }
    });

    $backToTop.unbind('click.smoothscroll').bind('click', function(e) {
      e.preventDefault();
      html.add(body).animate( { scrollTop: 0 }, duration);
      return false;
    })
}

// layout slider
theme.layoutSlider = function(sectionId, type) {
    var asNavFor = (type === 'img' ? 'text' : 'img');

    if (type === 'img') {
      $('.js-layout-slider-' + type + '-' + sectionId).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false,
        arrows: true,
        asNavFor: '.js-layout-slider-' + asNavFor + '-' + sectionId,
        responsive: [
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false
              }
          },
        ]
      });
    } else {
      $('.js-layout-slider-' + type + '-' + sectionId).slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          arrows: false,
          asNavFor: '.js-layout-slider-' + asNavFor + '-' + sectionId,
          responsive: [
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: false,
                      dots: true
                  }
              },
          ]
      });
    }

}

// magnific popup functions
theme.mfpOpen = function(popup) {
  var closeBtn = '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp">&times;</button>';

  switch(popup) {
    case 'prop-65':
      $.magnificPopup.open({
        items: {
          src: '.js-prop-65-draw'
        },
        type: 'inline',
        mainClass: 'mfp-medium',
        removalDelay: 200,
        showCloseBtn: true,
        closeBtnInsid: true,
        closeMarkup: closeBtn,
        closeOnBgClick: true
      });
   break;

    // product type popups (data coming from locales and added to theme object in layout.liquid)
    case 'thermoelectric':
    case 'compressor':

      var description = theme.strings.productTypes[popup].split('***');

      var data = {
        title: popup,
        description1: description[0],
        description2: description[1]
      }

      $.magnificPopup.open({
        key: 'my-popup',
        items: data,
        type: 'inline',
        mainClass: 'mfp-medium',
        removalDelay: 200,
        closeOnBgClick: true,
        inline: {
          // Define markup. Class names should match key names.
          markup: '<div class="layout-draw"><div class="mfp-close"></div>'+
                    '<div class="layout-draw__wrapper">'+
                      '<div class="layout-draw__header">'+
                        '<h3 class="mfp-title"></h3>'+
                      '</div>'+
                      '<div class="layout-draw__body"><div class="mfp-description1"></div></br><div class="mfp-description2"></div></div>'+
                    '</div>'+
                  '</div>'
        }
      });
    break
  }
}

// collection sort
theme.collectionSort = function() {
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  $('#sort-by')
    .bind('change', function() {
      Shopify.queryParams.sort_by = jQuery(this).val();
      location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    });
}

// show more module (fake load more by showing hidden items)
theme.showMore = function(parent) {
  var $parent = $(parent);
  var $targests = $parent.find('[data-show-more-item]');
  var $loadMore = $parent.find('.js-show-more');
  var itemsToShoww = 8;

    $targests.slice(0, itemsToShoww).show();

    $loadMore.on('click', function (e) {
        e.preventDefault();
        $targests.not(':visible').slice(0, itemsToShoww).slideDown();

        if ($targests.not(':visible').length == 0) {
          $loadMore.fadeOut('slow');
        }
        // html.add(body).animate({
        //     scrollTop: $(this).offset().top
        // }, 500);
    });
}

// utility to get json from a url and execute a callback
theme.getData = function(url, container, callback) {
  $.ajax({
    method: "GET",
    url: url,
    dataType: "json"
  })
  .done(function(data) {
    callback(data, container);
  })
  .fail(function(error) {
    console.log( "error", error );
  })
}

// render blog overview sections
theme.renderBlogOverview = function(data, container) {

  var month_map = {
    0 : 'Jan',
    1 : 'Feb',
    2 : 'Mar',
    3 : 'Apr',
    4 : 'May',
    5 : 'Jun',
    6 : 'Jul',
    7 : 'Aug',
    8 : 'Sep',
    9 : 'Oct',
    10 : 'Nov',
    11 : 'Dec'
  }

  // article item markup
  var markup = '';

  data.blog.forEach(function(article, index) {
    // format date
    var date = new Date(article.published_at);
    var formatted_date = month_map[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();


    // check if featured collection
    if (container.data('blog-section') === 'featured' && data.blog.length === 3) {

      if (index == 0) {
        markup += '<div class="col-xs-12 col-sm-8 blog__featured-large">' +
                      '<div class="blog__featured-item blog__featured-aspect-box">' +
                        '<div class="blog__featured-aspect-box-bg" style="background-image:url(' + article.image.src + ')"></div>' +
                        '<a href="/blogs/learn/' + article.handle + '">' +
                          '<div class="blog__featured-aspect-box-overlay">' +
                            '<div class="blog__featured-content">' +
                              '<p>' + article.title + '</p>' +
                              '<p>' + formatted_date + '</p>' +
                            '</div>' +
                          '</div>' +
                        '</a>' +
                      '</div>' +
                    '</div>';
      } else {
        if (index == 1) {
          markup += '<div class="col-xs-12 col-sm-4 blog__featured-small">';
        }

        markup += '<div class="blog__featured-item blog__featured-aspect-box">' +
                    '<div class="blog__featured-aspect-box-bg" style="background-image:url(' + article.image.src + ')"></div>' +
                    '<a href="/blogs/learn/' + article.handle + '">' +
                      '<div class="blog__featured-aspect-box-overlay">' +
                        '<div class="blog__featured-content">' +
                          '<p>' + article.title + '</p>' +
                          '<p>' + formatted_date + '</p>' +
                        '</div>' +
                      '</div>' +
                    '</a>' +
                  '</div>';

        if (index == 2) {
          markup += '</div>';
        }

      }

    } else {
      // get low and hiigh res image url
      var low_res_img = slate.Image.getSizedImageUrl(article.image.src, '400x');
      var high_res_img = slate.Image.getSizedImageUrl(article.image.src, '1000x');

      markup += '<div class="col-xs-12 col-sm-4 blog__section-item">'+
                '<div class="blog__section-item-view"><a href="/blogs/learn/' + article.handle + '">'+
                  '<img class="img-full lazyload blur-up" data-src="' + high_res_img + '" src="' + low_res_img + '" />'+
                '</a></div>'+
                '<div class="blog_section-item-details">'+
                  '<p><a href="/blogs/learn/' + article.handle + '">' + article.title + '</a></p>'+
                  '<p>' + formatted_date + '</p>'+
                  '<p>' + article.body_html.replace(/(<([^>]+)>)/ig,"").substring(0, 100) + ' - <a aria-label="read more about ' + article.title + '" href="/blogs/learn/' + article.handle + '">Read More</a></p>'+
                '</div>'+
              '</div>';
    }
  });

  setTimeout(function() {
    // append articles
    container.find('.blog__section-items').append(markup);
  }, 100)

}

var endOfVisiblePosts = 2;


jQuery('.article__related-post-item').each(function(index){
      if(index > endOfVisiblePosts){
        jQuery(this).hide();
      } else {
        jQuery(this).show();
      }
  });


jQuery(document).ready(function(){
  setTimeout(function(){
    function matchHeightImage() {
      jQuery('.bc-sf-filter-product-item-main-image').load(function() {
        var imageContainer = jQuery(this).parent();
        imageContainer.css('width', '100%').css('height', '260px');
      }).each(function() {
        if (this.complete) jQuery(this).load();
      });
    }
  }, 2000);
});

/*-- On tablet view stop redirection and show main navigation --*/
jQuery(document).ready(function(){
  if(($(window).width() >= 768) && ($(window).width() <= 1024)){
    var current_menu_item = jQuery('.main-navigation .main-navigation__list .main-navigation__list-item .menu_show_item');
    current_menu_item.on('click',function(e){
      e.preventDefault();
      jQuery(jQuery(this).attr('data-link')).toggleClass('visible')
    });
  }
});
/*-- NAA-Nov-121 Customer Photo Image Carousel--*/
jQuery(document).ready(function(){
  jQuery(document).on('click', '.demolink' , function(evt){
    evt.preventDefault();
    var youtubeLink = jQuery(this).attr('data-src');
    var html = '<iframe width="100%" src="https://www.youtube.com/embed/'+ youtubeLink +'?rel=0&enablejsapi=1" frameborder="0" allowfullscreen></iframe>';
    var targeted_popup_class = jQuery(this).attr('data-popup-open');
    jQuery('[data-popup="' + targeted_popup_class + '"]').fadeIn(350); 
    jQuery('[data-popup="' + targeted_popup_class + '"]').find('.modal-body').html(html);
  });
  jQuery(document).on('click', '.demoimage', function(e){
    e.preventDefault();
    var html = jQuery(this).html();
    var targeted_popup_class = jQuery(this).attr('data-popup-open');
    jQuery('[data-popup="' + targeted_popup_class + '"]').fadeIn(350); 
    jQuery('[data-popup="' + targeted_popup_class + '"]').find('.modal-body').html(html);
  });
  jQuery('[data-popup-close]').click(function(e)  {
    var targeted_popup_class = jQuery(this).attr('data-popup-close');
    jQuery('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);
    jQuery('.modal-body').html(' ');
    e.preventDefault();
  });
  
  jQuery('.custom__image-video-slider').slick({
    slidesToShow: 5,
    row: 0,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        }
      }
    ]
  });
  jQuery(".custom__carousel-image").on("click", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("custom__carousel-des");
  });
});

/*-- NAA-MAR-212 Homepage | Buying Guide Section --*/

jQuery(document).ready(function(){
  var options = {
    slidesToShow: 3,
    row: 0,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        }
      }
    ]
  }
  jQuery('.tabs li, .tab_drawer_heading ').on('click', function() {
    jQuery('.tab_content').slick('unslick');
    jQuery('.tab_content').slick(options);
  });
  jQuery('.tab_content').slick(options);
});

//NAA-July-229 New Header/Navigation-- toggle navigation

$(document).ready(function(){
  $('.dropdown-menu').on('click', function(e) {
    $(this).parent('li.has-item').toggleClass('show-submneu');
    $(this).parent('li.has-item').siblings().removeClass('show-submneu');
  });
  //
  $('.show-child2').on('click', function(e) {           
    $(this).parent('li').addClass('active-li');            
  });  
  $('.show-child3').on('click', function(e) {           
    $(this).parent('.child3-li').addClass('active-level3');            
  }); 
  $('.back-show-child3').on('click', function(e) {           
    $('.child3-li').removeClass('active-level3');            
  }); 
  $('.back-mainmenu').on('click', function(e) {           
    $('.main-navigation__list li').removeClass('active-li');            
  }); 
});

$(document).on('click', ".hamburger.opened", function() {
   $('.main-navigation__list li').removeClass('active-li');         
});
$(document).on('click', ".hamburger.opened", function() {
   $('.child3-li').removeClass('active-level3');         
});

freeGiftValidation(); 

/* Created Free Gift Feature Start */
function freeGiftValidation(){
  var min_order_val_250 = jQuery('.min-order-above-250').text();
  var min_order_val_400 = jQuery('.min-order-above-400').text();
  var min_order_val_750 = jQuery('.min-order-above-750').text();
  var gift_card_35 = parseInt(jQuery('.gift-card-35').text());
  var gift_card_60 = parseInt(jQuery('.gift-card-60').text());
  var gift_card_115 = parseInt(jQuery('.gift-card-115').text());
  Shopify.queue=[]
  let cart = jQuery.getJSON('/cart.js');
  cart.done(function(){
    cart = cart.responseJSON;
    let items = cart.items;
    let itemscount = cart.item_count;
    let total_price = cart.total_price/100;
    var finalprice = total_price;
    for (var i = 0; i < items.length; i++) {
        if (finalprice > min_order_val_250 && finalprice <= min_order_val_400) {
          if(items[i].gift_card == true){
            var giftprice = (items[i].price/100);
            finalprice = total_price - giftprice;
          }
        }
        else if (finalprice > min_order_val_400 && finalprice <= min_order_val_750) {
          if(items[i].gift_card == true){
            var giftprice = (items[i].price/100);
            finalprice = total_price - giftprice;
          }
        }
        else if (finalprice > min_order_val_750) { 
          if(items[i].gift_card == true){
            var giftprice = (items[i].price/100);
            finalprice = total_price;
          }
        }
      }
    let free_gift_array = [gift_card_35, gift_card_60, gift_card_115];
    let conditions = [min_order_val_250, min_order_val_400, min_order_val_750];
    let removeQueue = [];
    let item_ids = items.map(x => x.variant_id)
    let valid_conditions = [];
    let invalid_conditions = [];
    if(finalprice > 750){
      valid_conditions = [min_order_val_750];
      invalid_conditions = [min_order_val_250, min_order_val_400];
    } else if (finalprice <= 250 && itemscount >=1 )   {
      //invalid_conditions = [min_order_val_250,min_order_val_400,min_order_val_750];
    } else if (finalprice == 750 && itemscount >=1 )   {
      valid_conditions = [min_order_val_400];
      invalid_conditions = [min_order_val_250,min_order_val_750];
    } else if (finalprice > 400 && finalprice < 750 )   {
      valid_conditions = [min_order_val_400];
      invalid_conditions = [min_order_val_250,min_order_val_750];
    } else if (finalprice <= 400 && itemscount >=1 )   {
      valid_conditions = [min_order_val_250];
      invalid_conditions = [min_order_val_400,min_order_val_750];
    } else if (finalprice > 250 && finalprice <= 400 && itemscount >=1 )   {
      valid_conditions = [min_order_val_250];
      invalid_conditions = [min_order_val_400,min_order_val_750];
    }else {
      //valid_conditions = conditions.filter(x => finalprice >= x);
      //invalid_conditions = conditions.filter(x => finalprice < x);
    }
    // if conditions are valid push the free gift into the array
    for(var i=0;i<valid_conditions.length;i++){
      if (item_ids.indexOf(free_gift_array[conditions.indexOf(valid_conditions[i])]) == -1){
        Shopify.queue.push(free_gift_array[conditions.indexOf(valid_conditions[i])]);
      }
    }

    // if there are invalid conditions, find the index of the condition, and use it to access the free gift array to get the correct item
    for(var i=0;i<invalid_conditions.length;i++){
      if (item_ids.indexOf(free_gift_array[conditions.indexOf(invalid_conditions[i])]) != -1){
        removeQueue.push(free_gift_array[conditions.indexOf(invalid_conditions[i])]);
      }
    }

    function applyGifts(){
      if (Shopify.queue.length){
        let request = Shopify.queue.shift();
        Shopify.addItem(request, 1, {}, applyGifts);
      }else{
        location.reload();
      }
    }
    function removeGifts(){
      if (removeQueue.length){
        let request = removeQueue.shift();
        Shopify.removeItem(request, removeGifts);
      }else{
        location.reload();
      }
    }

    // if the add queue has anything in it, run the function
    if (Shopify.queue.length){
      applyGifts();
    }
    // if the remove queue has anything in it, run this function
    if(removeQueue.length){
      removeGifts();
    }

  });
}

$('body').on('click', '.pr-snippet-rating-count', function() {
//   $(".cc-tab-page").removeClass("cc-active-tp");
//   $("#cc-tab-4").addClass("cc-active-tp");
//   $(".cc-tab-link").removeClass("cc-tab-active");
//   $(".cc-tab-link[data-tab-id='cc-tab-4']").addClass("cc-tab-active");
//   $(".pr-rating-stars").trigger("click");
//   $(".pr-rating-stars").click();
  const innerTab = document.querySelectorAll('.cc-tab-inner li.cc-tab-list a');
  
  innerTab.forEach(function (heading,index) {
      let tocHtml =  heading.innerHTML;
      tocHtml.trim();
      if(tocHtml.trim() == "Reviews") {
          let countLink = index + 1;
          let linkAnchor = "cc-tab-"+countLink;
          $(".cc-tab-page").removeClass("cc-active-tp");
          $("#"+linkAnchor).addClass("cc-active-tp");
          $(".cc-tab-link").removeClass("cc-tab-active");
          $(".cc-tab-link[data-tab-id='"+linkAnchor+"']").addClass("cc-tab-active");
          $('html, body').animate({
               scrollTop: $('.product-reviews.product__section').offset().top - 330
          }, 500);
      }
  });
});

// Shopify.addItem = function(id, qty, properties, callback) {
//   var params = {
//     quantity: qty,
//     id: id
//   };
//   if(properties != false){
//     params.properties = properties;
//   }
//   $.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     dataType: 'json',
//     data: params,
//     success: function(){
//       if(typeof callback === 'function'){
//         callback();
//       }
//     },
//     error: function(){}
//   });
// }
/* Created Free Gift Feature End */

// if ($(window).width() > 767) {
//   $('.site-header .nav-mobile__search').remove();
// }
// if ($(window).width() < 767) {
//   $('.header-middle.hide-mobile').remove();
// }
// if ($(window).width() > 767) {
//   $('.section-footer__newsletter-mobile.hide--desktop').remove();
// }
// if ($(window).width() < 767) {
//   $('.section-footer__newsletter-desktop.hide--tablet').remove();
// }